enum StoryType {
    Comment = 1,
    Action = 2,
    Attachment = 3,
}

export default StoryType;
